import React, { useMemo } from "react";
import { PageSection, PageHeaderBar } from "components/page";
import { useQuery, QueryResponseHandler } from "components/graphql";
import Dashboard from "components/dashboard";
import { useCurrentCustomerContext } from "components/current-customer-context";
import { useAuthDataContext, Restricted, permissions } from "components/auth";
import { AssetData, getAssetQuery, ActionButtons } from "./details-page";
import { deleteAssetMutation } from "./table";
import { FormattedMessage } from "react-intl";

const AssetDetailsPage = ({
  match: {
    params: { id },
  },
  history,
}) => {
  const { hasAdminPrivileges } = useAuthDataContext();
  const { currentCustomerId } = useCurrentCustomerContext();
  const query = useMemo(() => getAssetQuery(id, currentCustomerId, hasAdminPrivileges), [
    id,
    currentCustomerId,
    hasAdminPrivileges,
  ]);
  const { data, loading, error } = useQuery(query);
  const asset = data.asset;

  return (
    <Dashboard>
      <QueryResponseHandler error={error} loading={loading} elements={asset}>
        <Restricted
          fallback={
            <h1>
              <FormattedMessage id="common.security.noAccess" />
            </h1>
          }
          permissions={[asset && asset.customerId ? permissions.asset_view : permissions.asset_common_view]}
        >
          <PageHeaderBar
            showBackButton
            title="app.page.asset.asset.details.assetName"
            titleParams={{ assetName: asset ? asset.codename : null }}
            buttons={
              <ActionButtons
                asset={asset}
                id={id}
                currentCustomerId={currentCustomerId}
                mutation={deleteAssetMutation}
                history={history}
              />
            }
          />
          <PageSection>
            <AssetData asset={asset} />
          </PageSection>
        </Restricted>
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default AssetDetailsPage;
